import { useMemo, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import "./GuitarTabs.css";

const GuitarTabsHome = () => {
  const { data, error } = useOutletContext();
  const [searchText, setSearchText] = useState("");

  const filteredTabs = useMemo(() => {
    if (!data) {
      return [];
    }

    const normalizedSearch = searchText.trim().toLowerCase();
    if (!normalizedSearch) {
      return data;
    }

    return data.filter((tab) => {
      const combinedFields = [
        tab.songName,
        tab.artist,
        tab.tuning,
        tab.difficulty,
        tab.notes,
      ]
        .join(" ")
        .toLowerCase();
      return combinedFields.includes(normalizedSearch);
    });
  }, [data, searchText]);

  return (
    <div className="GuitarTabsPage">
      <section className="GuitarTabsHero">
        <div>
          <p className="GuitarTabsEyebrow">Practice Library</p>
          <h1>Store and pull up your guitar tabs in one place.</h1>
          <p className="GuitarTabsIntro">
            Browse your saved songs, search by artist or tuning, and jump into a clean tab viewer
            built to work better on mobile.
          </p>
        </div>
        <div className="GuitarTabsHeroStats">
          <div>
            <span>{data ? data.length : 0}</span>
            <p>Saved tabs</p>
          </div>
          <div>
            <span>{filteredTabs.length}</span>
            <p>Search results</p>
          </div>
        </div>
      </section>

      <section className="GuitarTabsPanel">
        <div className="GuitarTabsSectionHeader">
          <h2>Saved library</h2>
          <p>Pick a song to open its dedicated viewer page.</p>
        </div>

        <div className="GuitarTabsActionRow">
          <input
            className="GuitarTabsSearch"
            placeholder="Search your tabs"
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
          />
          <Link className="GuitarTabsButtonLink" to="/guitar-tabs/add">
            Add New Tab
          </Link>
        </div>

        {error ? <p>Unable to load tabs right now.</p> : null}

        <div className="GuitarTabsLibraryGrid">
          {filteredTabs.map((tab) => (
            <Link
              key={tab.id}
              className="GuitarTabListItem GuitarTabLinkCard"
              to={`/guitar-tabs/view?tab=${tab.id}`}
            >
              <strong>{tab.songName}</strong>
              <span>{tab.artist}</span>
              <span>{tab.tuning || "Standard"} | {tab.difficulty || "Unrated"}</span>
              <span className="GuitarTabsDate">{tab.createdAt}</span>
            </Link>
          ))}
        </div>

        {filteredTabs.length === 0 ? (
          <p className="GuitarTabsEmptyState">No tabs match that search yet.</p>
        ) : null}
      </section>
    </div>
  );
};

export default GuitarTabsHome;
